import { Component, HostBinding, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'cs-layout',
  standalone: false,
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LayoutComponent {
  @HostBinding('class.cs-layout')
  public class = true;
}
